// extracted by mini-css-extract-plugin
export default {"read":"JumpButton_read__bErom","arrow":"JumpButton_arrow__IGpv+"};